// import dependencies
import types from "../constants";

export const requirementsSet = payload => ({
    "type": types.REQUIREMENTS_SET,
    payload
});
